export default __webpack_public_path__ + "static/media/feather.91d3670f.svg";